import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LocationService } from 'app/masters/location-master/location.service';
import { Observable, of, Subject } from 'rxjs';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { doctordataModal } from 'app/masters/models/service-master.model';
import { ExportService } from 'app/reports/services/export.service';

@Component({
  selector: 'app-doctor-accounting-module',
  templateUrl: './doctor-accounting-module.component.html',
  styleUrls: ['./doctor-accounting-module.component.scss']
})
export class DoctorAccountingModuleComponent implements OnInit {
  branchList: any[] = [];
  branchlistControl: FormControl;
  filteredbranchArray: Observable<any[]>;
  DoctorCtrl1: FormControl;
  filteredDoctorArray1: Observable<any[]>;
  doctorData: any[] = [];
  selectedbranchId: any;
  selecteddoctorId: any;
  doctordetailData:doctordataModal[]=[]
  searchValue: string = '';
  holddoctordetailData: any[];
  columnNames: string[] = ['After Discount','Share Type','Share Per','Share Flat'];
  selectedColumnName: any;
  enteredValue: any;
  showSpinner:boolean = false
  showButton :boolean = false
  destroydoctorAcc$: Subject<boolean> = new Subject<boolean>();
  
  constructor(private locationService:LocationService , private dashboardService:DashboardService,
              private exportdata: ExportService,
  ) { }

  ngOnInit(): void {
    this.getBranch()
    this.getDoctor()
  }

  editColumnWiseModal() {
    document.getElementById('editColumnWiseModal').style.display = 'block';
  }

  closeEditColumnWiseModal() {
    document.getElementById('editColumnWiseModal').style.display = 'none';
    this.selectedColumnName = ''
    this.enteredValue = ''
  }

    getBranch() {
      this.locationService.getallBranches().pipe(takeUntil(this.destroydoctorAcc$)).subscribe((branch: any[]) => {
        this.branchList = branch;
        this.initializebranchControl();
      });
    }
  
    initializebranchControl() {
      this.branchlistControl = new FormControl();
      this.filteredbranchArray = this.branchlistControl.valueChanges.pipe(
        startWith(''),
        map((branchList) =>
          branchList
            ? this.filterbranchlistFunction(branchList)
            : this.branchList.slice()
        )
      );
    }
  
    filterbranchlistFunction(name: string): any[] {
      return this.branchList.filter((b) =>
        b.branchName.toLowerCase().includes(name.toLowerCase())
      );
    }
    getDoctor() {
        this.dashboardService.getall_doctors().pipe(takeUntil(this.destroydoctorAcc$))
        .subscribe((doctor: any[]) => {
          this.doctorData = doctor
          this.initializedoctorControl()  
        });
      }

      initializedoctorControl(){
        this.DoctorCtrl1 = new FormControl();
        this.filteredDoctorArray1 = this.DoctorCtrl1.valueChanges.pipe(
          startWith(''),
          map((docList) =>
            docList
              ? this.filterdocFun(docList)
              : this.doctorData.slice()
          )
        );

      }

      filterdocFun(name: string): any[] {
        return this.doctorData.filter((b) =>
          b.userName.toLowerCase().includes(name.toLowerCase())
        );
      }
  
      onbranchSelected(branch){
        const selectedBranch = this.branchList.find((b: any) => b.branchName == branch);
          if (selectedBranch) {
            this.selectedbranchId = selectedBranch.pkBranchId || null;
          }
      }
  
      ondoctorSelected(doctor){
        const selectedDoctor = this.doctorData.find((b: any) => b.userName == doctor);
        if (selectedDoctor) {
          this.selecteddoctorId = selectedDoctor.userId || null ;
        }
      }

      onInputClear(event: any, field: string) {
        const value = event.target.value.trim();
        
        if (!value) {
          if (field === 'branch') {
            this.selectedbranchId = null;
            this.doctordetailData =[]
            this.showButton = false;
          } else if (field === 'doctor') {
            this.selecteddoctorId = null;
            this.doctordetailData =[]
            this.showButton = false;
          }
        }
      }
      showData(){
        if (!this.selectedbranchId) {
          this.locationService.openSnackBar('Please select a Branch', 'OK');
          return;
        }
        if (!this.selecteddoctorId) {
          this.locationService.openSnackBar('Please select a Doctor', 'OK');
          return;
        }
        this.getdoctordetailData(this.selectedbranchId,this.selecteddoctorId)
      }

      getdoctordetailData(branch , dr){
        this.showSpinner = true
        this.locationService.GetDoctorShareDetailByBranchIdByDoctorId(branch , dr).pipe(takeUntil(this.destroydoctorAcc$)).subscribe((data: any[]) => {
          this.doctordetailData = data
          this.holddoctordetailData = data
          this.showSpinner = false
          this.sortDoctorDetailData();
          if(this.doctordetailData.length == 0){
            this.showButton = false
          }else{
            this.showButton = true
          }
          });
      }
      sortDoctorDetailData() {
        this.doctordetailData.sort((a, b) => b.pK_TranId - a.pK_TranId);
      }

      applydrFilter(search:string): void{
        if(!this.holddoctordetailData || this.holddoctordetailData.length == 0 ){
          return
        }
        if(!search){
          this.doctordetailData = [...this.holddoctordetailData]
          return
        }
        const filterText = search.toLowerCase();
        this.doctordetailData = this.holddoctordetailData.filter((item)=>{
          const branchName = item.branchName?.toLowerCase().includes(filterText);
          const serviceName = item.serviceName?.toLowerCase().includes(filterText);
          const userName = item.userName?.toLowerCase().includes(filterText);
         return branchName ||serviceName|| userName
        })        
      }
      editService(service: any) {
        service.isEdit = true; 
      }
      
      saveService(service: any) {
        if (service.shareType === 'P' && parseFloat(service.sharePer) > 100) {
          this.locationService.openSnackBar('Share percentage  cannot be greater than 100', 'OK');
          return;
        }
        service.isEdit = false; 
        this.updateServiceData(service); 
        this.showButton = true
      }
      validateSharePer(service: any) {
        if (service.shareType === 'P' && parseFloat(service.sharePer) > 100) {
          service.sharePer = 0; 
          this.locationService.openSnackBar('Share percentage  cannot be greater than 100', 'OK');
        }
      }
      
      updateServiceData(service: any) {
        console.log("Updated Service Data:", service);
      }
    
      savedrData(){
        this.showSpinner = true
        let hasInvalidPer = this.holddoctordetailData.some(item => item.sharePer > 100);
        if (hasInvalidPer) {
          this.dashboardService.openSnackBar('Share percentage  cannot be greater than 100', 'OK');
          this.showSpinner = false
          return;
        }
        const validdrData = [...this.holddoctordetailData];
        var drdataArray = []

        validdrData.forEach((data) => {
          if (!(data.sharePer == 0 && data.shareFlat == 0)) {
            let payload = {
              "PK_TranId": data.pK_TranId > 0 ? data.pK_TranId : 0,
              "FK_BranchId": this.selectedbranchId,
              "FK_DoctorId": this.selecteddoctorId,
              "FK_ServiceId": data.fK_ServiceId,
              "ShareType": data.shareType,
              "SharePer": data.sharePer,
              "ShareFlat": data.shareFlat,
              "IsAfterDiscount": data.isAfterDiscount == "Y" ? true : data.isAfterDiscount == "N" ? false : data.isAfterDiscount,
              "IsEdit": data.pK_TranId > 0 ? true : false
            };
            drdataArray.push(payload);
          }
        });
        if (drdataArray.length === 0) {
          this.showSpinner = false; 
          return;
        }
      
      const data ={
        InsertDoctorShareDetail:drdataArray
      }
      const isfirstrecordEdit =data.InsertDoctorShareDetail[0]?.IsEdit

      this.locationService.InsertDoctorShareDetail(data).pipe(takeUntil(this.destroydoctorAcc$)).subscribe((response:any)=>{
        if(response.statusCode ==1 ){
          if(isfirstrecordEdit){
            this.locationService.openSnackBar('Record updated successfully', 'OK');
          }else{
            this.locationService.openSnackBar('Record saved successfully', 'OK');
          }
          this.getdoctordetailData(this.selectedbranchId,this.selecteddoctorId)
          this.showButton = false
          this.showSpinner = false
        }
        else if(response.statusCode == 10){
          this.locationService.openSnackBar('Already exists in the list', 'OK');
          this.showSpinner = false
        }
      },
      (err) => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
        this.showSpinner = false
    })
      }

      columnMapping = {
        'After Discount': 'isAfterDiscount',
        'Share Type': 'shareType',
        'Share Per': 'sharePer',
        'Share Flat': 'shareFlat'
      };
      
      updateColumnValues() {
        if (this.selectedColumnName === 'Share Per') {
          const numericValue = parseFloat(this.enteredValue);
          if (numericValue > 100) {
            this.locationService.openSnackBar('Share percentage  cannot be greater than 100', 'OK');
            return;
          }
        }
      
        const colKey = this.columnMapping[this.selectedColumnName];
      
        if (!colKey) {
          this.locationService.openSnackBar('Invalid column selection', 'OK');
          return;
        }
      
        if (this.enteredValue === undefined || this.enteredValue === null || this.enteredValue === '') {
          this.locationService.openSnackBar('Please enter a value', 'OK');
          return;
        }
      
        const uniqueShareTypes = new Set(this.doctordetailData.map(row => row.shareType));
      
        if (this.selectedColumnName === 'Share Flat' && uniqueShareTypes.size === 1 && uniqueShareTypes.has('P')) {
          this.locationService.openSnackBar("Cannot update 'Share Flat' when all Share Types are 'P'", 'OK');
          return;
        }
      
        if (this.selectedColumnName === 'Share Per' && uniqueShareTypes.size === 1 && uniqueShareTypes.has('F')) {
          this.locationService.openSnackBar("Cannot update 'Share Per' when all Share Types are 'F'", 'OK');
          return;
        }
      
        this.doctordetailData.forEach(row => {
          if (this.selectedColumnName === 'After Discount') {
            row[colKey] = this.enteredValue === 'Y';
          }
          else if (this.selectedColumnName === 'Share Flat' && row.shareType === 'F') {
            row[colKey] = this.enteredValue; 
          } 
          else if (this.selectedColumnName === 'Share Per' && row.shareType === 'P') {
            row[colKey] = this.enteredValue;
          }
           else if (this.selectedColumnName === 'Share Type'){
            row[colKey] = this.enteredValue;
          }
        });
      
        this.closeEditColumnWiseModal();
        this.showButton = true;
      }
      
      apptexportexcel(): void {
        // let element = document.getElementById('contentappd');
        // this.exportdata.exportxcel(element);
  //  this.exportdata.open_loader_Dialogtwo();
    let element = document.getElementById('contentappd');
    this.exportdata.Newexportxcel(element, 'Doctor_AccoutingModule List');
      }
      ngOnDestroy(){
        this.destroydoctorAcc$.next(true)
        this.destroydoctorAcc$.unsubscribe()
        this.branchList = [];
        this.branchlistControl = null;
        this.filteredbranchArray = null;
        this.DoctorCtrl1 = null;
        this.filteredDoctorArray1 = null;
        this.doctorData = [];
        this.selectedbranchId = null;
        this.selecteddoctorId = null;
        this.doctordetailData = [];
        this.holddoctordetailData = [];
        this.searchValue = '';
        this.selectedColumnName = null;
        this.enteredValue = null;
        this.showSpinner = false;
        this.showButton = false;
      }
      onShareTypeChange(service: any) {
        if (service.shareType === 'P') {
          service.shareFlat = 0; 
        } else if (service.shareType === 'F') {
          service.sharePer = 0; 
        }
      }
      
      roundToTwo(value: any) {
        if (!value) return 0;
        return parseFloat(value).toFixed(2);
      }

      formatDecimal(value: any): string {
        if (value === null || value === undefined || value === '') {
          return '';
        }
        
        let num = parseFloat(value);
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
      }
      
      
}
